module.exports = __webpack_public_path__ + "static/BlackMinimalistMarketingProposal(2)_optimized-0aa9e6b38a3c63c149fba1c3375462c8.png";